import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import PromotionalOne from "../components/PromotionalOne";
import HotDealsOne from "../components/HotDealsOne";
import DeliveryOne from "../components/DeliveryOne";
import OrganicOne from "../components/OrganicOne";
import NewArrivalOne from "../components/NewArrivalOne";
import ShippingOne from "../components/ShippingOne";
import NewsletterTwo from "../components/NewsletterTwo";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
const HomePageOne = () => {
  return (
    <>
      
      <Preloader />
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />
      {/* ColorInit */}
      <ColorInit color={true} />
      {/* HeaderOne */}
      <HeaderOne />
      {/* BannerOne */}
      <BannerOne />
      {/* FeatureOne */}
      <FeatureOne />
      {/* PromotionalOne */}
      <PromotionalOne />
      {/* FlashSalesOne */}
      {/* HotDealsOne */}
     <HotDealsOne />
      {/* BestSellsOne */}
      {/* DeliveryOne */}
      <DeliveryOne />
      {/* OrganicOne */}
      <OrganicOne />
      {/* NewArrivalOne */}
      <NewArrivalOne />
      {/* ShippingOne */}
      <ShippingOne />
      {/* NewsletterOne */}
      <NewsletterTwo />
      {/* FooterOne */}
      <FooterOne />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};
export default HomePageOne;
